<script setup lang="ts">
import { ref, computed } from 'vue';
import { useMainStore } from '../../store';
import { useLeadSubmit } from '../../composables/useLeadSubmit';
import { useGateAnalytics } from '../../composables/useGateAnalytics';
import type { Gate, QuizData } from '../../types';
import type { TemplateDefinition } from '../../templates';

// Core gate block (DEV-1135): the SAME money path as legacy Gate.vue — both
// consume useLeadSubmit/useGateAnalytics, so there is exactly one
// implementation of lead assembly, POST, cookies, analytics and redirect.
// The template's gate component is presentation only; consent (LGPD checkbox,
// UTUA-style) is a gate-config feature rendered by the template and carried
// on the lead payload as `consent`.
defineProps<{ template: TemplateDefinition }>();

const store = useMainStore();
const quizData = store.quizData as QuizData;
const gate = (store.gateData || {}) as Gate;
const form = ref(store.formLead);
const consentState = ref({ checked: false });

useGateAnalytics(quizData, form);

const hasConsent = !!gate.consent_checkbox;
const { submit, skip } = useLeadSubmit(
  quizData,
  form,
  hasConsent ? { consent: computed(() => consentState.value.checked) } : undefined
);
</script>

<template>
  <component
    :is="template.gate"
    :gate="gate"
    :quiz="quizData"
    :form="form"
    :consent="consentState"
    :fetching="store.fetching"
    @submit="submit"
    @skip="skip"
  />
</template>
